import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { styled } from '@mui/material';
import { useIsMinified } from '../../hooks';
import { useCallback } from 'react';
import useNavigation from '@libComponents/NavigationContainer/useNavigation';

const propTypes = {
    name: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    icon: PropTypes.string,
    childRoutes: PropTypes.array,
    depth: PropTypes.number
};

const defaultProps = {
    icon: void 0,
    depth: 0,
    childRoutes: []
};

const Wrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 'var(--accordionPadding)',
    overflow: 'hidden'
});
const Icon = styled('img')(({ theme: { spacing } }) => ({
    width: spacing(3),
    height: spacing(3),
    marginLeft: spacing(1.5),
    marginRight: spacing(1.5),
    flexShrink: 0
}));
const StyledLink = styled(Link)(({ theme: { palette, typography } }) => {
    return {
        color: palette.text.success,
        fontFamily: typography.fontFamily,
        fontWeight: 'var(--activeFontWeight)',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            textDecoration: 'underline'
        },
        '&:focus, &:focus-visible, &.Mui-focusVisible': {
            outline: 'none !important',
            boxShadow: 'none !important'
        }
    };
});

const RouteHeader = ({ icon, name, route, childRoutes, depth }) => {
    const isMinified = useIsMinified();
    const hasChildren = !!childRoutes.length;

    const [{ isDrawerVisible }, dispatch] = useNavigation();

    const handleMenu = useCallback(
        () =>
            dispatch({
                type: 'setDrawerVisibility',
                payload: !isDrawerVisible
            }),
        [dispatch, isDrawerVisible]
    );

    return hasChildren ? (
        <Wrapper data-testid={`${name}-wrapper`}>
            <Icon
                src={icon}
                alt={`${name}-Icon`}
                data-testid={`${name}-icon`}
            />
            {!isMinified && (
                <StyledLink
                    data-testid={`${name}-link`}
                    onClick={window.innerWidth <= 768 && handleMenu}
                    to={childRoutes[0].route}
                >
                    {name}
                </StyledLink>
            )}
        </Wrapper>
    ) : (
        <StyledLink
            data-testid={`${name}-link`}
            to={route}
            onClick={window.innerWidth <= 768 && handleMenu}
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'var(--minifyJustify)',
                paddingLeft: 'var(--accordionPadding)'
            }}
        >
            <Icon src={icon} alt={`${name}-Icon`} />
            {!isMinified && name}
        </StyledLink>
    );
};

RouteHeader.propTypes = propTypes;
RouteHeader.defaultProps = defaultProps;

export default RouteHeader;
